import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: null,
    authenticated: false,
    user: {},
    menu: [],
    fcm: null,
    reload: false,
    company: {
      company_name: 'VISUALITY',
      logo: require('@/assets/logo/logo_color.png')
    },
    color: '#0786BE',
    baseurllocal: ''
  },
  mutations: {
    setToken(state, accessToken) {
      state.token = accessToken
      state.authenticated = true
    },
    setUser(state, accessUser) {
      state.user = accessUser
    },
    setMenu(state, accessMenu) {
      state.menu = accessMenu
    },
    setFcm(state, accessFcm) {
      state.fcm = accessFcm
    },
    setReload(state, accessReload) {
      state.reload = accessReload
    },
    setCompany(state, accessCompany) {
      state.company = accessCompany
    },
    setColor(state, accessColor) {
      state.color = accessColor
    },
    setBaseurllocal(state, accessBaseurllocal) {
      state.baseurllocal = accessBaseurllocal
    }
  },
  actions: {},
  modules: {}
})